import RealtimeRide from "./realtimeRide.service";

const realtimeRideModule = angular
  .module("app.services.realtimeRide", [])
  .service("RealtimeRide", RealtimeRide);

export default realtimeRideModule;



// WEBPACK FOOTER //
// ./src/services/realtimeRide/realtimeRide.module.js